import { Link, useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { BUSINESS } from "@/data/content";

const StickyMobileCTA = () => {
  const { pathname } = useLocation();
  if (pathname === "/contact") return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t border-teal-line bg-black/95 backdrop-blur-md lg:hidden" data-testid="sticky-mobile-cta">
      <a href={BUSINESS.phoneHref} data-testid="sticky-call-btn" className="flex items-center justify-center gap-2 py-4 font-display text-sm font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:text-mint">
        <Phone className="h-4 w-4" aria-hidden="true" /> Call Now
      </a>
      <Link to="/contact" data-testid="sticky-quote-btn" className="flex items-center justify-center bg-mint py-4 font-display text-sm font-bold uppercase tracking-wide text-black transition-colors duration-200 hover:bg-white">
        Get a Quote
      </Link>
    </div>
  );
};

export default StickyMobileCTA;
